import React, { FC } from 'react';

import { Flex } from '@adsk/alloy-react-box';
import ContentLoader from '@adsk/alloy-react-content-loader';
import Divider from '@adsk/alloy-react-divider';
import theme from '@adsk/alloy-react-theme';

import { TableLoader } from './TableLoader';

const TitleLoader: FC = () => {
  return (
    <Flex height="106px" width="100%" alignItems="center">
      <ContentLoader
        width="329"
        height="29"
        backgroundColor={theme.colors.charcoal200}
        foregroundColor={theme.colors.charcoal100}
      >
        <rect height="29" rx="10" ry="10" width="329" x="0" y="0" />
      </ContentLoader>
    </Flex>
  );
};

const FooterLoader: FC = () => {
  return (
    <Flex width="auto" height="auto">
      <ContentLoader
        height="29"
        width="500"
        backgroundColor={theme.colors.charcoal200}
        foregroundColor={theme.colors.charcoal100}
      >
        <rect height="16" rx="8" ry="8" width="205" x="0" y="12" />
        <rect height="16" rx="8" ry="8" width="205" x="230" y="12" />
      </ContentLoader>
    </Flex>
  );
};

export const ContentLayoutLoader: FC = () => {
  return (
    <Flex
      data-testid="ContentLayoutLoader"
      flexDirection="column"
      flex={1}
      paddingTop={theme.spacing.XXL}
      paddingX={theme.spacing.XXL}
      paddingBottom={theme.spacing.M}
      height="100%"
    >
      <TitleLoader />
      <Divider />
      <TableLoader />
      <Divider />
      <FooterLoader />
    </Flex>
  );
};

export default ContentLayoutLoader;
